module.exports = __webpack_public_path__ + "img/header_logo.28cd7a41.png";